var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/search_icon.6251014c.png","uri@2x": __webpack_public_path__ + "static/media/search_icon.18d696df.png","uri@3x": __webpack_public_path__ + "static/media/search_icon.285f4dd4.png",
    width: 18,
    height: 18
});